/**
 * kullaniciListe.js — Kullanıcılar sayfasının liste durumu (backlog #379).
 *
 * Kişi Listesi'nin (#262) yaptığı gibi arama, sıralama, süzgeçler ve sayfa ADRES ÇUBUĞUNDA tutulur:
 * Kullanıcı Kartı'ndan "Kullanıcılara Dön" ile dönünce hepsi yerinde durur. Adresten YALNIZCA açılışta okunur;
 * sonrasında sayfanın state'i asıl, adres onun yansımasıdır (replace ile yazılır).
 *
 * Süzgeç anahtarları `GET /users/kullanici-listesi` parametreleriyle aynıdır (backend #378, /rbac/users'ın sorgusu).
 * Sayfa 1-tabanlı tutulur, uca 0-tabanlı gider.
 *
 * WAS (#379, 2026-10-13): "Tümü | Personel | Firma Tarafı" düğmeleri (`taraf`, uçta `staff`). Deniz 2026-10-18: denetmen tarafında
 * yalnızca tüm kullanıcılar görünsün, personel / firma ayrımı gerekmez; 2026-10-26 (#545) düğmeler ve kartın köşe şeridi kalktı.
 * Eski bir yer imindeki `?taraf=` yok sayılır (ilk yazımda adresten silinir). Uçtaki `staff` parametresi duruyor, bu sayfa göndermez.
 *
 * Etiketler çeviri ANAHTARIDIR (`components` ad alanı, `kullaniciListe.*`); çizen bileşen `t()` ile çevirir.
 */

export const SAYFA_BOYU = 20;

export const SIRALAMALAR = [
  { key: "ad", etiketKey: "kullaniciListe.siralama.ad" },
  { key: "sonGiris", etiketKey: "kullaniciListe.siralama.sonGiris" },
  { key: "kayit", etiketKey: "kullaniciListe.siralama.kayit" },
  { key: "rol", etiketKey: "kullaniciListe.siralama.rol" },
];

export const FIRMA_ROLLERI = [
  { value: "1", etiketKey: "kullaniciListe.firmaRolu.katilimci" },
  { value: "2", etiketKey: "kullaniciListe.firmaRolu.organizator" },
  { value: "3", etiketKey: "kullaniciListe.firmaRolu.dekorator" },
  { value: "4", etiketKey: "kullaniciListe.firmaRolu.taseron" },
];

/** Düz değerli süzgeçler (adreste aynı adla); `firma` ayrı: nesne, adreste firmaId + firmaAdi. */
const DUZ_ANAHTARLAR = [
  "groupId", "active", "firmaVar", "firmaNation", "firmaTypeId", "fuarId", "girisVar", "sonGirisBaslangic", "sonGirisBitis",
];

export const BOS_FILTRE = {
  groupId: "", active: "", firma: null, firmaVar: "", firmaNation: "", firmaTypeId: "",
  fuarId: "", girisVar: "", sonGirisBaslangic: "", sonGirisBitis: "",
};

/** Adresten liste durumu: { arama, sirala, sayfa, filtre }. */
export function listeDurumuOku(sp) {
  const filtre = { ...BOS_FILTRE };
  DUZ_ANAHTARLAR.forEach((k) => { filtre[k] = sp.get(k) || ""; });
  const firmaId = Number(sp.get("firmaId"));
  if (firmaId > 0) filtre.firma = { firmaId, firmaName: sp.get("firmaAdi") || `#${firmaId}` };
  const sirala = SIRALAMALAR.some((s) => s.key === sp.get("sirala")) ? sp.get("sirala") : "ad";
  return { arama: sp.get("q") || "", sirala, sayfa: Math.max(1, Number(sp.get("sayfa")) || 1), filtre };
}

/** Liste durumunu mevcut adres parametrelerinin üstüne yazar (başka parametrelere dokunmaz); varsayılanlar adreste durmaz. */
export function listeDurumunuYaz(sp, { arama, sirala, sayfa, filtre }) {
  const next = new URLSearchParams(sp);
  const koy = (k, v) => { if (v) next.set(k, String(v)); else next.delete(k); };
  next.delete("taraf"); // #545: eski yer imi
  koy("q", arama);
  koy("sirala", sirala !== "ad" ? sirala : "");
  koy("sayfa", sayfa > 1 ? sayfa : "");
  DUZ_ANAHTARLAR.forEach((k) => koy(k, filtre[k]));
  koy("firmaId", filtre.firma?.firmaId);
  koy("firmaAdi", filtre.firma ? filtre.firma.firmaName || filtre.firma.firmaShortname : "");
  return next;
}

/** `GET /users/kullanici-listesi` parametreleri; `size` / `page` (0-tabanlı) dahil. */
export function listeParametreleri({ arama, sirala, sayfa, filtre }) {
  return {
    q: arama,
    groupId: filtre.groupId,
    active: filtre.active,
    firmaId: filtre.firma?.firmaId,
    firmaVar: filtre.firmaVar,
    firmaNation: filtre.firmaNation,
    firmaTypeId: filtre.firmaTypeId,
    fuarId: filtre.fuarId,
    girisVar: filtre.girisVar,
    sonGirisBaslangic: filtre.sonGirisBaslangic,
    sonGirisBitis: filtre.sonGirisBitis,
    sort: sirala,
    page: sayfa - 1,
    size: SAYFA_BOYU,
  };
}

/**
 * Aktivasyon maili (#572) uçlarının süzgeç parametreleri: listenin KENDİ süzgeci (sort / page / size hariç). Backend kümeyi bununla kendisi kurar;
 * sayfa hiçbir zaman kimlik listesi göndermez.
 */
export function topluAktivasyonParametreleri({ arama, filtre }) {
  return {
    q: arama,
    groupId: filtre.groupId,
    active: filtre.active,
    firmaId: filtre.firma?.firmaId,
    firmaVar: filtre.firmaVar,
    firmaNation: filtre.firmaNation,
    firmaTypeId: filtre.firmaTypeId,
    fuarId: filtre.fuarId,
    girisVar: filtre.girisVar,
    sonGirisBaslangic: filtre.sonGirisBaslangic,
    sonGirisBitis: filtre.sonGirisBitis,
  };
}

/** Toplu aktivasyon maili yalnızca bir arama ya da en az bir süzgeç varken önerilir (backend süzgeçsiz isteği zaten reddeder). */
export function topluSuzgecVar({ arama, filtre }) {
  return Boolean(arama) || aktifFiltreSayisi(filtre) > 0;
}

/** "Filtreler" düğmesindeki sayı: dolu süzgeç sayısı (arama ve sıralama dahil değil — onlar araç çubuğunda görünür). */
export function aktifFiltreSayisi(filtre) {
  return DUZ_ANAHTARLAR.filter((k) => filtre[k] !== "").length + (filtre.firma ? 1 : 0);
}
